<ng-content select="gax-page-section-header"></ng-content>
<ng-content select="gax-page-section-table-header"></ng-content>
<ng-content select="gax-page-section-content"></ng-content>
<ng-content></ng-content>
